export default "__VITE_ASSET__ZKz9jSff__"